import React from 'react';
import Seo from '../components/common/Seo';
import ImageSlider from '../components/home/slider/ImageSlider';
import StatsSection from '../components/home/stats/StatsSection';
import AboutSection from '../components/home/about/AboutSection';
import WhatWeOffer from '../components/home/products/WhatWeOffer';
import WhyChooseUs from '../components/home/features/WhyChooseUs';
import SalesSection from '../components/home/sales/SalesSection';
import RetailNetworkSection from '../components/home/retail/RetailNetworkSection';
import BestSelling from '../components/home/sales/BestSelling';
import BranchNetworkSection from '../components/home/branch/BranchNetworkSection';
import TestimonialSection from '../components/home/testimonials/TestimonialSection';
import FAQ from '../components/home/faq/FAQ';

const Home = () => {
  return (
    <div className="w-full">
      <Seo
        title="Agastya Agro Limited | Crop Protection Solutions for India"
        description="Boost crop health with trusted insecticides, fungicides, herbicides, and PGRs from Agastya Agro, built for Indian farms and proven in the field."
      />
      {/* Hero Section with Image Slider */}
      <section className="w-full bg-[linear-gradient(103.51deg,#EEF2F6_25.5%,#FFFFFF_39%,#EEF2F6_49%,#FFFFFF_55%,#EEF2F6_59%)]">
        <div className="max-w-[1440px] mx-auto ">
          <ImageSlider />
        </div>
      </section>
      
      {/* Stats Section */}
      <section className="w-full">
        <StatsSection />
      </section>
      
      {/* About Section */}
      <section className="w-full">
        <AboutSection />
      </section>

      {/* What We Offer Section */}
      <section className="w-full bg-[#F9F9FB]">
        <WhatWeOffer />
      </section>
      
      {/* Why Choose Us Section */}
      <section className="w-full bg-white py-8 hidden md:block">
        <WhyChooseUs />
      </section>

      {/* Sales Section */}
      <section className="w-full">
        <SalesSection />
      </section>

      {/* Retail Network Section */}
      <section className="w-full hidden md:block">
        <RetailNetworkSection />
      </section>

      <section className="w-full bg-[#F9F9FB]"> 
        <BestSelling />
      </section>
      
      {/* Branch Network Section */}
      <section className="w-full">
        <BranchNetworkSection />
      </section>

      {/* Testimonial Section */}
      <section className="w-full">
        <TestimonialSection />
      </section>

      {/* FAQ Section */}
      <section className="w-full">
        <FAQ />
      </section>
    </div>
  );
};

export default Home;
